import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStackSection } from './components/ValueStackSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-charcoal" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <RecentPurchaseToast data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <HookSection data-id="element-5" />
        <AgitationSection data-id="element-6" />
        <RevelationSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <ValueStackSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>

      <footer className="bg-charcoal text-white/60 py-8 text-center text-sm" data-id="element-14">
        <div className="max-w-4xl mx-auto px-4" data-id="element-15">
          <p data-id="element-16">
            © {new Date().getFullYear()} El Protocolo de la Mañana. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-50" data-id="element-17">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}